import { html } from "lit";
var icon_exit_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      fill-rule="evenodd"
      d="M16 4a1.2 1.2 0 110 2.4H6.4v19.2H16a1.2 1.2 0 110 2.4H5.2A1.2 1.2 0 014 26.8V5.2A1.2 1.2 0 015.2 4zm5.166 6.365a1.2 1.2 0 011.682-.015l4.8 4.8a1.199 1.199 0 01.001 1.698l-4.8 4.8a1.202 1.202 0 01-2.024-.529c-.11-.42.015-.866.327-1.167l2.752-2.752H10a1.2 1.2 0 110-2.4h13.904l-2.753-2.753a1.2 1.2 0 01.015-1.682z" />
  </svg>
`;
export {
  icon_exit_default as default
};
//# sourceMappingURL=icon-exit.js.map
